import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAIPrompt } from '../context/AIPromptContext';

/**
 * Hook to set static page metadata for AI prompt generation
 * @param {Object} metadata - Page metadata object
 * @param {string} metadata.title - Page title
 * @param {string} metadata.description - Page description
 * @param {string} metadata.pageType - Type of page (e.g., 'service', 'homepage', 'contact')
 * @param {string} metadata.content - Full page content for AI analysis
 */
export const usePageMetadata = (metadata) => {
  const { updatePageMetadata } = useAIPrompt();
  const location = useLocation();
  const hasUpdated = useRef(false);

  useEffect(() => {
    // Only update once when component mounts
    if (!hasUpdated.current) {
      updatePageMetadata({
        ...metadata,
        url: window.location.origin + location.pathname
      });
      hasUpdated.current = true;
    }
  }, []);
};
